const CONTROL_CHARS = /[\u0000-\u0009\u000B-\u001F\u007F]/;
export const normalizeFamilyFestEventPageValue = (value) => (value ?? '')
    .replace(/\r\n?/g, '\n')
    .trim()
    .replace(/\n{3,}/g, '\n\n');
export const isAllowedFamilyFestEventPageUrl = (value) => {
    if (!value || /\s/.test(value))
        return false;
    if (value.startsWith('#'))
        return /^#[A-Za-z0-9_-]+$/.test(value);
    if (value.startsWith('/'))
        return !value.startsWith('//') && !value.includes('\\');
    try {
        const url = new URL(value);
        return url.protocol === 'https:' && !!url.hostname;
    }
    catch {
        return false;
    }
};
export const validateFamilyFestEventPageValue = (field, submittedValue) => {
    const value = normalizeFamilyFestEventPageValue(submittedValue);
    if (!value)
        return null;
    if (CONTROL_CHARS.test(value))
        return { key: 'invalidCharacters' };
    if (value.length > field.maxLength)
        return { key: 'tooLong', limit: field.maxLength };
    if (field.type === 'Url')
        return isAllowedFamilyFestEventPageUrl(value) ? null : { key: 'invalidUrl' };
    if (field.type === 'Text' && value.includes('\n'))
        return { key: 'singleLineOnly' };
    if (field.maxLines && value.split('\n').length > field.maxLines)
        return { key: 'tooManyLines', limit: field.maxLines };
    if (field.maxParagraphs && value.split('\n\n').length > field.maxParagraphs)
        return { key: 'tooManyParagraphs', limit: field.maxParagraphs };
    return null;
};
export const FAMILY_FEST_EVENT_PAGE_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp'];
export const validateFamilyFestEventPageImage = (field, file) => {
    if (!FAMILY_FEST_EVENT_PAGE_IMAGE_TYPES.includes(file.type))
        return 'imageInvalidType';
    if (field.maxBytes && file.size > field.maxBytes)
        return 'imageTooLarge';
    return null;
};
/** Single-line types must not contain line breaks; multi-line types may up to their caps. */
export const familyFestEventPageFieldAllowsLineBreaks = (field) => field.type === 'Multiline' || (field.type === 'Heading' && (field.maxLines ?? 1) > 1);
